export default "__VITE_ASSET__9bGjMBIR__"